import { AuditAccessibilityModel } from "./auditAccessibility.model";

export class AuditProjectArtifactModel {
    constructor() {
        this.articraftDTO = [];
    }
    // id: number;
    auditid: number;
    comments: string;
    articraftDTO : Array<AuditAccessibilityModel> = [];
    // isActive: boolean;
}